import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AuthCallback from "./components/AuthCallback";
import { Toaster } from "./components/ui/sonner";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import Leads from "./pages/Leads";
import BulkPreview from "./pages/BulkPreview";
import LinkedInAutomation from "./pages/LinkedInAutomation";
import Pipeline from "./pages/Pipeline";
import Sequences from "./pages/Sequences";
import Meetings from "./pages/Meetings";
import Qualification from "./pages/Qualification";
import Triage from "./pages/Triage";
import Outreach from "./pages/Outreach";
import Nurture from "./pages/Nurture";
import WarmIntros from "./pages/WarmIntros";
import Sprint from "./pages/Sprint";
import PublicLanding from "./pages/PublicLanding";
import Enrollments from "./pages/Enrollments";
import LinkedInPage from "./pages/LinkedInPage";
import LeadFinder from "./pages/LeadFinder";
import Analytics from "./pages/Analytics";
import Deliverability from "./pages/Deliverability";
import GoLive from "./pages/GoLive";
import SettingsPage from "./pages/Settings";

function AppRouter() {
  const location = useLocation();
  // Synchronous detection of session_id in hash (must happen during render before ProtectedRoute mounts)
  if (typeof window !== "undefined" && location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/auth-callback" element={<AuthCallback />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/go-live" element={<ProtectedRoute><GoLive /></ProtectedRoute>} />
      <Route path="/leads" element={<ProtectedRoute><Leads /></ProtectedRoute>} />
      <Route path="/bulk-preview" element={<ProtectedRoute><BulkPreview /></ProtectedRoute>} />
      <Route path="/linkedin-auto" element={<ProtectedRoute><LinkedInAutomation /></ProtectedRoute>} />
      <Route path="/pipeline" element={<ProtectedRoute><Pipeline /></ProtectedRoute>} />
      <Route path="/sequences" element={<ProtectedRoute><Sequences /></ProtectedRoute>} />
      <Route path="/enrollments" element={<ProtectedRoute><Enrollments /></ProtectedRoute>} />
      <Route path="/qualification" element={<ProtectedRoute><Qualification /></ProtectedRoute>} />
      <Route path="/triage" element={<ProtectedRoute><Triage /></ProtectedRoute>} />
      <Route path="/outreach" element={<ProtectedRoute><Outreach /></ProtectedRoute>} />
      <Route path="/meetings" element={<ProtectedRoute><Meetings /></ProtectedRoute>} />
      <Route path="/nurture" element={<ProtectedRoute><Nurture /></ProtectedRoute>} />
      <Route path="/warm-intros" element={<ProtectedRoute><WarmIntros /></ProtectedRoute>} />
      <Route path="/sprint" element={<ProtectedRoute><Sprint /></ProtectedRoute>} />
      <Route path="/site/:slug" element={<PublicLanding />} />
      <Route path="/linkedin" element={<ProtectedRoute><LinkedInPage /></ProtectedRoute>} />
      <Route path="/lead-finder" element={<ProtectedRoute><LeadFinder /></ProtectedRoute>} />
      <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
      <Route path="/deliverability" element={<ProtectedRoute><Deliverability /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
